var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.9999V13.9999C7 11.4333 9.1 9.33325 11.6667 9.33325H18.6667",
    stroke: "#F0338C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 9.33341L14 4.66675L18.6667 9.33341L14 14.0001",
    stroke: "#F0338C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3668 20.0664H31.0335C29.6335 20.0664 28.4668 18.8998 28.4668 17.4998V6.99977C28.4668 5.59977 29.6335 4.43311 31.0335 4.43311H47.3668C48.7668 4.43311 49.9335 5.59977 49.9335 6.99977V17.4998C49.7001 18.8998 48.7668 20.0664 47.3668 20.0664Z",
    stroke: "#F0338C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25.6667H44.3333",
    stroke: "#F0338C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6676 45.7332H9.33424C7.93424 45.7332 6.76758 44.5665 6.76758 43.1665V32.6665C6.76758 31.2665 7.93424 30.0999 9.33424 30.0999H25.6676C27.0676 30.0999 28.2342 31.2665 28.2342 32.6665V43.1665C28.0009 44.5665 26.8342 45.7332 25.6676 45.7332Z",
    stroke: "#F0338C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3008 51.3334H22.6341",
    stroke: "#F0338C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.333 46.6667L41.9997 42",
    stroke: "#F0338C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.333 46.6667L41.9997 51.3334L37.333 46.6667",
    stroke: "#F0338C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9997 35V42C48.9997 44.5667 46.8997 46.6667 44.333 46.6667H37.333",
    stroke: "#F0338C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/Community.94e041bd4afeb7a2188c7670fa6c14db.svg";
export { ForwardRef as ReactComponent };